import { render } from "./StockField.vue?vue&type=template&id=330f2583&scoped=true&ts=true"
import script from "./StockField.vue?vue&type=script&lang=ts"
export * from "./StockField.vue?vue&type=script&lang=ts"

import "./StockField.vue?vue&type=style&index=0&id=330f2583&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330f2583"]])

export default __exports__